import { MarketplaceInfo } from '../api/v1-api/helpers';

/**
 * Returns the appropriate domain based on the marketplace type
 * @param marketplace The marketplace object
 * @returns The domain string (withloma.com or loma.tech)
 */
export const getMarketplaceDomain = (marketplace?: MarketplaceInfo | null): string => {
  return marketplace?.withloma ? 'withloma.com' : 'loma.tech';
};

/**
 * Returns the full URL for the Loma website
 */
export const getLomaWebsiteUrl = (): string => {
  return 'https://www.loma.tech/';
};
